<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" *ngIf="isOpen && !oneLine">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
    <p class="font-15" [class.font-bold]="fontBold">{{data?.name}}</p>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
    <p class="font-15" [class.font-bold]="fontBold">{{data?.address}}</p>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1" *ngIf="data?.address2">
    <p class="font-15" [class.font-bold]="fontBold">{{data?.address2}}</p>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="data?.zipAndTownship">
    <p class="font-15" [class.font-bold]="fontBold">{{data?.zipAndTownship}}</p>
  </div>
</div>

<div class="row" *ngIf="oneLine">
  <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
    <span class="font-15 text-left" [class.font-bold]="fontBold">{{data?.name}}</span>
  </div>

  <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
    <span class="font-15 text-center" [class.font-bold]="fontBold">{{data?.address}}</span>
  </div>

  <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3" *ngIf="data?.address2">
    <span class="font-15 text-center" [class.font-bold]="fontBold">{{data?.address2}}</span>
  </div>

  <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3" *ngIf="data?.zipAndTownship">
    <span class="font-15 text-right" [class.font-bold]="fontBold">{{data?.zipAndTownship}}</span>
  </div>
</div>
